import { CONNECTION_ERROR } from '../BasePage'

import { isNotValidScadenzaPolizza } from '../../libs/validation/dateValidation'
import { isValidPrivacy } from "../../components/privacy/BasicPrivacy"

import { isNotValidDataInzioViaggio, isNotValidDataFineViaggio } from '../../libs/validation/dateValidation'
import { isEmpty } from "../../libs/validation/stringRegex"
import { UserType } from "../../libs/user/User"

import { authFetch } from '../../libs/cookie/Cookie'

import * as Constants from '../../costants'

export async function stepTwoValidation (
    altriSinistri: boolean | undefined,
    polizzaAttiva: boolean | undefined,
    scadenzaPolizza: string | undefined,
    tipo_viaggio: string | undefined,
    destinazione: string | undefined,
    data_inizio: string | undefined,
    data_fine: string | undefined,
    durata: string | undefined,
    soggetti: string | undefined,
    eta: number | undefined,
    eta_assicurato_1: number | undefined,
    eta_assicurato_2: number | undefined,
    numero_figli: string | undefined,
    numero_partecipanti: number | undefined,
    eta_partecipanti: string | undefined,
    tipo_copertura: string | undefined,

    user: UserType | undefined,
    noMotorPrivacy: any,

    printErrorCallBack: Function,
    manageExpiredSessionsCallBack: Function
) {
    let error = undefined

    if (altriSinistri === undefined) {
        error = 'SINISTRI'
    }
    else if (polizzaAttiva === undefined) {
        error = 'POLIZZA'
    }
    else if (
        polizzaAttiva === true && 
        isNotValidScadenzaPolizza(scadenzaPolizza)
    ) {
        error = 'SCADENZA_POLIZZA'
    }
    else if (tipo_viaggio === undefined) {
        return "TIPO_VIAGGIO"
    }
    else if (tipo_viaggio === 'polizzaAnnuale' && durata === undefined) {
        return "DURATA"
    }
    else if (
        tipo_viaggio === 'viaggioSingolo' && 
        isNotValidDataInzioViaggio( data_inizio, data_fine ) 
    ) {
        return "DATA_INIZIO"
    }
    else if (
        tipo_viaggio === 'viaggioSingolo' && 
        isNotValidDataFineViaggio( data_inizio, data_fine ) 
    ) {
        return "DATA_FINE"
    }

    else if (destinazione === undefined) {
        return "DESTINAZIONE"
    }
    
    
    else if (soggetti === undefined) {
        return "SOGGETTI"
    }
    else if (
        (
            soggetti === 'singolaPersona' ||
            soggetti === 'genitoreConFigli' 
        ) && 
        (
            eta === undefined ||
            Number(eta) < 18
        )
    ) {
        return "ETA"
    }
    else if (
        (soggetti === 'famiglia' || soggetti === 'coppia') && 
        isNotAlmenoUnMaggiorenne ( eta_assicurato_1, eta_assicurato_2 )
    ) {
        return "ETA_ASSICURATO_1"
    }
    else if (
        (soggetti === 'famiglia' || soggetti === 'coppia') && 
        isNotAlmenoUnMaggiorenne ( eta_assicurato_2, eta_assicurato_1 )
    ) {
        return "ETA_ASSICURATO_2"
    }
    else if (
        (
            soggetti === 'famiglia' ||
            soggetti === 'genitoreConFigli' 
        ) && 
        numero_figli === undefined
    ) {
        return "NUMERO_FIGLI"
    }
    else if (
        soggetti === 'gruppo' && 
        (numero_partecipanti === undefined || Number(numero_partecipanti) < 3)
    ) {
        // min 3 partecipanti --> se no coppia
        return "NUMERO_PARTECIPANTI"
    }
    else if (soggetti === 'gruppo' && eta_partecipanti === undefined) {
        return "ETA_PARTECIPANTI"
    }
    else if (isEmpty( tipo_copertura ) ) {
        return "TIPO_COPERTURA"
    }
    else if (isValidPrivacy(noMotorPrivacy, user !== undefined)) {
        return 'PRIVACY'
    }
    else {
        await authFetch (
            Constants.STEP_2_VALIDATION_URL,
            {
                method: "post",
                body: JSON.stringify({
                    specificData: {
                        sinistriPrecedenti: altriSinistri ?? null,
                        polizzaGiaAttiva: polizzaAttiva ?? null,
                        dataScadenza: scadenzaPolizza ?? null,
                        tipo_viaggio: tipo_viaggio ?? null,
                        destinazione: destinazione ?? null,
                        data_inizio: data_inizio ?? null,
                        data_fine: data_fine ?? null,
                        durata: durata ?? null,
                        soggetti: soggetti ?? null,
                        eta: eta ?? null,
                        eta_assicurato_1: eta_assicurato_1 ?? null,
                        eta_assicurato_2: eta_assicurato_2 ?? null,
                        numero_figli: numero_figli ?? null,
                        numero_partecipanti: numero_partecipanti ?? null,
                        eta_partecipanti: eta_partecipanti ?? null,
                        tipo_copertura: tipo_copertura ?? null
                    },
                    privacy: noMotorPrivacy ?? null,
                    isLogged: (user !== undefined)
                })
            },
            manageExpiredSessionsCallBack,
        ).then ( jsonObj => {
            if (jsonObj.status > 200) {
                error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
            }
        }).catch( error => {
            error = CONNECTION_ERROR
        })
    }

    printErrorCallBack (error)

    return error
}


function isNotAlmenoUnMaggiorenne ( a: number | undefined, b: number | undefined ) {
        if (a === undefined) {
            return true
        }
        else {
            if (b === undefined) {
                return Number(a) < 18
            }
            else {
                return Number(a) < 18 && Number(b) < 18
            }
        }
    }